import React from 'react';
import SimplePage from '../../layout/SimplePage/SimplePage';
import Container from '../../layout/Container/Container';
import Steps from './components/Steps';
import ErrorDisplay from './components/ErrorDisplay';
import StepRenderer from './components/StepRenderer';
import { useFinalizePage } from './hooks/useFinalizePage';

const FinalizePage = () => {
  const {
    step,
    setStep,
    error,
    registerData,
    cancelRegistration,
    onConfirmSchedule,
    onCancelRegistration,
  } = useFinalizePage();

  return (
    <SimplePage>
      <Container>
        <Steps current={step} />
        <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          {error && <ErrorDisplay error={error} />}
          <StepRenderer
            step={step}
            setStep={setStep}
            registerData={registerData}
            cancelRegistration={cancelRegistration}
            onConfirmSchedule={onConfirmSchedule}
            onCancelRegistration={onCancelRegistration}
          />
        </div>
      </Container>
    </SimplePage>
  );
};

export default FinalizePage;
